var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isOpen),expression:"isOpen"}],class:{
      screen: true,
      'is-open': _vm.isOpen,
    },attrs:{"id":_vm.id,"role":"main","tabindex":"-1"}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }